import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  addPayrocMerchantAccount,
  AddPayrocMerchantAccountPayload,
} from 'api/admin/businesses/addPayrocMerchantAccount';

export const useAddPayrocMerchant = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, AddPayrocMerchantAccountPayload>({
    mutationFn: async ({ merchantId, businessId }) => {
      return addPayrocMerchantAccount({
        merchantId,
        businessId,
      });
    },
    onSuccess: async () => {
      toaster('Payroc Merchant Account has been added', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while adding merchant account', {
        icon: '❌',
      });
      return error;
    },
  });
};
